import { ARTICLE_ENTITY_PREFIX_MAP } from '../../pages/articles/articlesConfigDefaults';

/**
 * Mirror general-settings patches into module namespaces so list pages and
 * config hooks see changes immediately (no Save-only reload).
 */
export function propagateGeneralSettingsToModules(merged, updates) {
  if (!merged || !updates || typeof updates !== 'object') return merged;

  if (updates.taxes?.tva != null) {
    const rate = updates.taxes.tva;
    merged.facturation = { ...(merged.facturation || {}), defaultTaxRate: rate };
    merged.articles = { ...(merged.articles || {}), defaultTaxRate: rate };
  }

  if (updates.configuration?.documentPrefixes) {
    merged.facturation = {
      ...(merged.facturation || {}),
      documentPrefixes: {
        ...(merged.facturation?.documentPrefixes || {}),
        ...updates.configuration.documentPrefixes,
      },
    };
  }

  if (updates.configuration?.entityPrefixes) {
    const ep = updates.configuration.entityPrefixes;
    merged.facturation = {
      ...(merged.facturation || {}),
      entityPrefixes: {
        ...(merged.facturation?.entityPrefixes || {}),
        ...ep,
      },
    };
    const articlesPatch = { ...(merged.articles || {}) };
    Object.entries(ARTICLE_ENTITY_PREFIX_MAP).forEach(([entityKey, configKey]) => {
      if (ep[entityKey] != null) {
        articlesPatch[configKey] = ep[entityKey];
      }
    });
    merged.articles = articlesPatch;
  }

  if (updates.regional?.currency) {
    merged.invoicing = {
      ...(merged.invoicing || {}),
      defaultCurrency: updates.regional.currency,
    };
  }

  return merged;
}
